import { Box } from '@mui/material'
import { FormattedMessage, useIntl } from 'react-intl'

import { tokens } from '@configuration/theme'
import SplitAuthLayout from '@components/SplitAuthLayout/SplitAuthLayout.component'
import BackToLogin from '@components/BackToLogin/BackToLogin.component'

const NotFoundPage = () => {
  const intl = useIntl()
  return (
    <SplitAuthLayout
      heading={intl.formatMessage({ id: 'notFound.welcome' })}
      dataTestId='not-found-page'
      back={<BackToLogin />}
    >
      <Box sx={{ color: tokens.businessBlack60, fontSize: 14, lineHeight: 1.4 }}>
        <FormattedMessage id='notFound.body' />
      </Box>
    </SplitAuthLayout>
  )
}

export default NotFoundPage
